<div class="primary-box container">
  <img src="/assets/logo-full.svg" alt="TRACit" height="75">

  <h1 class="mb-4">
    We've encountered an error!
  </h1>

  <p>
    {{ message || 'Sorry, but something isn\'t quite right.' }} Please <a href="/">try again</a>, and if problems
    persist, don't hesitate to contact us:
    <br>
    <br>
    telephone: <a href="tel:1300872248">1300 872 248</a>; or
    <br>
    email: <a href="mailto:sapport@tracit.com.au">support&#64;tracit.com.au</a>
  </p>
</div>
